import axios from 'axios'
import PostBase from './PostBase'
import Post, {IPost} from '@/models/Post'
import Tag, {ITag} from '@/models/Tag'
import PageBase from '@/pages/page-base'
import { apiV1TagPath } from '@/rails/routes'

export default abstract class PostNew extends PostBase {
  path: string
  createPath: string

  async mounted(): Promise<void> {
    super.mounted()
    const res = await axios.get<IPost>(this.targetPath)
    try {
      this.post = this.toFrontModel(res.data)
      this.loading = false
    } catch (e) {
      console.error(e)
    }
    const rootTag = await axios.get<ITag>(apiV1TagPath(this.tagCategory))
    this.tags = new Tag(rootTag.data).children
  }

  async onSave(): Promise<void> {
    const post = await this.save()
    this.$router.push(`/admin/${this.path}/${post.id}/edit`)
  }

  async save(): Promise<Post> {
    try {
      const res = await axios.post<IPost>(this.createPath, {
        post: this.post.toParams()
      })
      this.showMessage('変更を保存しました。')
      return this.toFrontModel(res.data)
    } catch (e) {
      console.log(e)
    }
  }
}
